import { AdSpendCard as BaseAdSpendCard } from '@features/campaigns/components/AdSpendCard';
import { useCurrentAdSpend } from '../../hooks/useAdSpend';
import {
  useReturnOnAdSpend,
  UseReturnOnAdSpendOptions,
} from '@features/campaigns/hooks/useCalculatedFields';
import { HeroMetric } from '@features/campaigns/components/Summary/HeroMetric';
import { formatters } from '@utils/formattersV2';
import { faDollar } from '@fortawesome/pro-solid-svg-icons';

type AdSpendCardProps = {
  campaign: UseReturnOnAdSpendOptions['campaign'];
  reportDate: UseReturnOnAdSpendOptions['reportDate'];
  incrementalSales: UseReturnOnAdSpendOptions['sales'];
  totalSales: UseReturnOnAdSpendOptions['sales'];
};

export const AdSpendCard = (props: AdSpendCardProps) => {
  const adSpendHook = useCurrentAdSpend();
  const { value: iroas } = useReturnOnAdSpend({
    campaign: props.campaign,
    reportDate: props.reportDate,
    sales: props.incrementalSales,
    adSpend: adSpendHook.adSpend,
  });

  const { value: roas } = useReturnOnAdSpend({
    campaign: props.campaign,
    reportDate: props.reportDate,
    sales: props.totalSales,
    adSpend: adSpendHook.adSpend,
  });

  return (
    <BaseAdSpendCard
      color="sales"
      metrics={[
        {
          key: 'iroas',
          render: () => (
            <HeroMetric
              value={iroas}
              valueFormatter={formatters.currency}
              colorScheme="sales"
              label="IROAS (Incremental Return on Ad Spend)"
              icon={faDollar}
              data-testid="iroas"
            />
          ),
        },
        {
          key: 'roas',
          render: () => (
            <HeroMetric
              value={roas}
              valueFormatter={formatters.currency}
              colorScheme="sales"
              label="ROAS (Return on Ad Spend)"
              icon={faDollar}
              data-testid="roas"
            />
          ),
        },
      ]}
    >
      <HeroMetric
        value={adSpendHook.adSpend}
        label="Ad Spend"
        icon={faDollar}
        valueFormatter={value =>
          formatters.currency(value, { full: true, decimals: 0 })
        }
        colorScheme="sales"
        data-testid="ad-spend"
      />
    </BaseAdSpendCard>
  );
};
